import { render, staticRenderFns } from "./CardVisualBox.vue?vue&type=template&id=73fe67f0&scoped=true&"
import script from "./CardVisualBox.vue?vue&type=script&lang=js&"
export * from "./CardVisualBox.vue?vue&type=script&lang=js&"
import style0 from "./CardVisualBox.vue?vue&type=style&index=0&id=73fe67f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fe67f0",
  null
  
)

export default component.exports